module.exports = __webpack_public_path__ + "static/woman-worried.6f9f6029.jpg";